import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Countdown } from './components/Countdown';
import { Hero } from './components/Hero';
import { Chapters } from './components/Chapters';
import { Carousel } from './components/Carousel';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { BuySection } from './components/BuySection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-accent-base selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Countdown data-id="element-2" />

      <main className="flex-1" data-id="element-3">
        <Hero data-id="element-4" />
        <Chapters data-id="element-5" />
        <Carousel data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Bonuses data-id="element-8" />
        <BuySection data-id="element-9" />
      </main>

      <footer className="bg-brand-dark py-8 text-center border-t border-white/5" data-id="element-10">
        <p className="text-gray-500 text-sm" data-id="element-11">
          © {new Date().getFullYear()} Handball Performance Pro. Todos los
          derechos reservados.
        </p>
        <p className="text-gray-600 text-xs mt-2 max-w-xl mx-auto px-4" data-id="element-12">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>

      <PurchasePopup data-id="element-13" />
    </div>;
}